////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const scheduledPricesManager = {
	getScheduledPrices: (filters = {}, queryParams = { page: '0', size: '250', sort: 'createdDate', nameDir: 'asc' }, toggledLines = false) => ({
		type: ActionsTypes.GET_SCHEDULED_PRICES,
		payload: {
			filters,
			queryParams,
			toggledLines,
		},
	}),
	getScheduledPricesSuccess: (data, toggledLines = false) => ({
		type: ActionsTypes.GET_SCHEDULED_PRICES_SUCCESS,
		payload: {
			data,
			toggledLines,
		},
	}),
	getScheduledPricesFailure: (error) => ({
		type: ActionsTypes.GET_SCHEDULED_PRICES_FAILURE,
		payload: {
			error,
		},
	}),
	getTransmission: (idCampaign) => ({
		type: ActionsTypes.GET_TRANSMISSION,
		payload: {
			idCampaign,
		},
	}),
	getTransmissionSuccess: (data) => ({
		type: ActionsTypes.GET_TRANSMISSION_SUCCESS,
		payload: {
			data,
		},
	}),
	getTransmissionFailure: (error) => ({
		type: ActionsTypes.GET_TRANSMISSION_FAILURE,
		payload: {
			error,
		},
	}),
	getPriceCampaignNestedLines: (idCampaign, withTtc) => ({
		type: ActionsTypes.GET_PRICE_CAMPAIGN_NESTED_LINES,
		payload: {
			idCampaign,
			withTtc,
		},
	}),
	getPriceCampaignNestedLinesSuccess: (data) => ({
		type: ActionsTypes.GET_PRICE_CAMPAIGN_NESTED_LINES_SUCCESS,
		payload: {
			data,
		},
	}),
	getPriceCampaignNestedLinesFailure: (error) => ({
		type: ActionsTypes.GET_PRICE_CAMPAIGN_NESTED_LINES_FAILURE,
		payload: {
			error,
		},
	}),
	resetScheduledPricesManager: () => ({
		type: ActionsTypes.RESET_SCHEDULED_PRICES_MANAGER_ITEMS,
	}),
}

export default scheduledPricesManager
